import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { OrderEntry } from '@spartacus/cart/base/root';
import { I18nModule } from '@spartacus/core';
import { ModalService } from '../../../../../../components/modal-list/modal-list.service';

@Component({
  selector: 'modal-see-notes',
  standalone: true,
  imports: [CommonModule, I18nModule, ReactiveFormsModule],
  templateUrl: './modal-see-notes.component.html',
  styleUrl: './modal-see-notes.component.scss',
})
export class ModalSeeNotesComponent implements OnInit {
  @Input() data!: {
    entry: OrderEntry;
    setNotes: Function;
  };

  form: UntypedFormGroup = this.fb.group({
    notes: ['', [Validators.maxLength(150)]],
  });

  constructor(
    protected fb: UntypedFormBuilder,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.form.get('notes')?.setValue(this.data.entry.notes || '');
  }

  cancel() {
    this.modalService.close();
  }

  submit() {
    const notes = this.form.get('notes')?.value || '';
    this.data.setNotes(notes);
    this.cancel();
  }
}
